var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6911 9.52099C14.087 9.79817 14.6326 9.70197 14.9097 9.30611C15.1869 8.91026 15.0907 8.36466 14.6949 8.08748L11.8278 6.07996C11.432 5.80278 10.8864 5.89898 10.6092 6.29484C10.332 6.69069 10.4282 7.23629 10.8241 7.51347L13.6911 9.52099Z",
    stroke: "#828282",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 12.4062C15.6875 11.923 15.2957 11.5312 14.8125 11.5312C14.3293 11.5312 13.9375 11.923 13.9375 12.4062V14.1562C13.9375 14.6395 14.3293 15.0312 14.8125 15.0312C15.2957 15.0312 15.6875 14.6395 15.6875 14.1562V12.4062Z",
    stroke: "#828282",
    strokeWidth: 0.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0508 8.00301C16.8369 7.56746 16.4629 7.12667 15.9287 6.68063C13.8122 4.94753 12.1227 3.64774 10.8602 2.78125C10.3852 2.78374 9.80333 2.78374 9.11467 2.78125L7.78695 4.52397C7.0336 4.51669 6.60461 4.51669 6.5 4.52397C6.44172 4.52802 5.62009 4.52802 4.03511 4.52397V4.72521C4.16767 5.59352 4.26217 6.24532 4.31863 6.68063C4.35161 6.93557 4.39096 7.25755 4.33041 7.6753C4.28422 7.99337 4.20049 8.22657 4.12189 8.43804C3.85072 9.16777 3.7151 9.53258 3.50362 9.96962C3.02279 10.9634 2.8615 12.1265 2.71228 13.2135C2.53465 14.5072 2.53351 15.6824 2.61325 16.6888C2.75762 16.9533 2.90209 17.2178 3.04646 17.4823C5.13192 17.5858 7.31015 17.6476 9.57438 17.6554C12.137 17.6642 14.5913 17.6031 16.9276 17.4897C17.0961 17.2187 17.2645 16.9479 17.4329 16.6769C17.4335 14.3903 17.4342 12.1037 17.4347 9.817C17.4385 9.71786 17.44 9.57979 17.4287 9.4158C17.4225 9.32639 17.3706 8.6546 17.0508 8.00301Z",
    stroke: "#828282",
    strokeWidth: 0.875
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 2.34375H3.875V4.09375H4.75V2.34375Z",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 2.34375H6.5V4.09375H7.375V2.34375Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.34375H4.75V3.21875H6.5V2.34375Z",
    fill: "#828282"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.21875H4.75V4.09375H6.5V3.21875Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.f6b94f45fa5c42949fb0c67f41acf9b4.svg";
export { ForwardRef as ReactComponent };